/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityType } from './capabilityType';


export interface AssignableCapabilityApiModel { 
    capabilityId: number;
    name: string;
    type: CapabilityType;
    specification: string;
    code: string;
    category?: number | null;
}
export namespace AssignableCapabilityApiModel {
}


